import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import basicCourseImage3 from '../assets/images/placement.avif';
import basicCourseImage1 from '../assets/images/panel2.webp';
import basicCourseImage2 from '../assets/images/panel3.webp';
import 'animate.css';  // Import Animate.css

const images = [basicCourseImage1, basicCourseImage2, basicCourseImage3]; // Array of images

const PlacementAssistance = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate(); // Initialize useNavigate hook

  // Define an array of content objects for easy rotation
  const contentArray = [
    {
      heading: "From Fresher To Professional",
      subheading: "We have got you covered!",
      // assistance: "Get Placement Assistance"
    },
    {
      heading: "Unlock Your Career Potential",
      subheading: "Join Our Training Programs!",
      assistance: "Expert Guidance & Support"
    },
    {
      heading: "Achieve Your Dreams with Us",
      // subheading: "Get Trained, Get Placed!",
      assistance: "Real-world Training & Job Support"
    },
    
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % contentArray.length); // Loop through content array
    }, 5000); // Change content every 5 seconds (5000 milliseconds)

    return () => clearInterval(interval); // Cleanup on unmount
  }); // Adding an empty dependency array to ensure the effect runs only once on mount

  // Get content based on currentIndex
  const { heading, subheading, assistance } = contentArray[currentIndex];

  // Handle the button click to navigate to /query (ContactForm)
  const handleButtonClick = () => {
    navigate('/query');  // Redirect to the /query route (ContactForm)
  };

  return (
    <div style={styles.container}>
      <div style={styles.imageContainer}>
        <div style={styles.imageWrapper}>
          {/* Render the current image based on currentIndex */}
          <img
            src={images[currentIndex]}
            alt="Course"
            style={styles.image}
          />
        </div>
        <div style={styles.textOverlay}>
          <h2 className="animate__animated animate__zoomInDown" style={styles.heading}>{heading}</h2>
          <p className="animate__animated animate__zoomInDown" style={styles.subheading}>{subheading}</p>
          <p className="animate__animated animate__zoomInDown" style={styles.placementAssistance}>{assistance}</p>
          <div style={styles.buttonContainer}>
            <button style={styles.button} onClick={handleButtonClick}>
              Register. Get Trained. Get Placed.
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    overflow: 'hidden',
    marginBottom: '35px',
  },
  imageContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageWrapper: {
    overflow: 'hidden',
    width: '100%', // You can adjust the width here as per your design
    height: '100%', // Adjust the height based on your requirement
    borderRadius: '8px',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '8px',
  },
  textOverlay: {
    position: 'absolute',
    top: '20%', // Adjusted for vertical positioning
    left: '3%', // Moved a bit more to the left
    color: '#fff',
    // textShadow: '1px 1px 3px rgba(0, 0, 0, 0.7)',
    padding: '10px',
    textAlign: 'left', // Text aligned to the left
    zIndex: 2, // Ensure text stays on top of image
  },
  heading: {
    fontSize: '60px',
    margin: '0',
    fontFamily: 'Georgia, serif',
    color:'black'
  },
  subheading: {
    fontSize: '36px',
    margin: '5px 0',
    fontFamily: 'Verdana, sans-serif',
  },
  placementAssistance: {
    fontSize: '32px',
    fontWeight: 'bold',
    margin: '10px 0',
    fontFamily: 'Courier New, monospace',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'left',
    marginTop: '10px',
  },
  button: {
    backgroundColor: '#B80000',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    padding: '12px 24px',
    fontSize: '20px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    outline: 'none',
  },
};

export default PlacementAssistance;
